/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { useApolloClient, useQuery, useLazyQuery } from '@apollo/client';
import { Helmet } from 'react-helmet';
import { Box, Button as MuiButton } from '@material-ui/core';
import { useGlobal, globalizationPath } from '@rcg/ui-react';

import Button from '../../components/UiComponents/Button';
import SearchTabs from '../../components/SearchTabs';
import QuestionsUnified from '../../components/QuestionsUnified';
import WhyChooseUsUnified from '../../components/WhyChooseUsUnified';
import useStyles from './index.style';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-x_blue.svg';
import {
  setSessionStorageItem,
  getSessionStorageItem,
} from '../../operations/sessionStorage/utils';
import { trackInteraction } from '../../utils/analytics/bookFlightsTracking';
import setSelectedDeparture from '../../operations/localState/setSelectedDeparture';
import setSelectedReturn from '../../operations/localState/setSelectedReturn';
import {
  SESSION_STORAGE_BOOKING_TOKEN_NAME,
  SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
  SESSION_STORAGE_BOOKING_PROFILE_NAME,
  SESSION_STORAGE_AMEND_ORIGIN,
  SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS,
  SESSION_STORAGE_AIR_REDIRECT_ERROR,
  GA_PROFILE_BOOKINGS_LENGTH,
  SHOW_CH_ERROR_BANNER,
  TRACK_INCORRECT_SAILING,
  SESSION_STORAGE_CHANGE_FLIGHTS,
  TRAVEL_AGENT_RESERVE,
  CANCEL_FLIGHT_RESPONSE_SUCCESSFUL,
  APPLICATION_NAME,
  ENABLE_CRUISE_BOOKING_TYPE_FLAG,
  ENABLE_SIGN_IN_FLAG,
  REDIRECTION_MANAGE,
  SESSION_STORAGE_FLIGHT_TYPE_CODE,
  TRAVEL_AGENT,
  TRACK_LOCKED,
  TRACK_STATUS_CANCELLED,
  TRACK_ERROR_CANCELLED,
  BANNER_TYPES,
  TRACK_INVAID,
  FLIGHT_AGENCY_ERROR,
  NAVIGATION_PATHS,
  ERROR_CODE293,
  ERROR_CODE017,
  SESSION_STORAGE_NAVIGATION_HISTORY_LAST_ENTRY,
  BOOKING_COUNTRY,
  COOKIE_KEYS,
  SUPPORT_PHONE_NUMBER_LD_FLAG,
  SEARCH_SAME_AIRPORT_ERROR,
  ACE_FS_1006_ERROR,
  ACE_FS_1028_ERROR,
  ACE_FS_1019_ERROR,
} from '../../utils/constants';
import getBrand from '../../utils/getBrand';
import { LDUser } from '../../utils/ldUser';
import commonUtils, {
  hasGuestUndefined,
  findErrorMessage,
  getCookies,
  getAmendAuthRedirection,
} from '../../utils/common';
import setSearchType from '../../operations/localState/setSearchType';
import setHeldReservation from '../../operations/localState/setHeldReservation';
import { setSearchParams, setBrowseParams } from '../../operations/localState/setSearchParams';
import { setBookingProfile, setBookingToken } from '../../operations/localState/setBookingProfile';
import { prefixPathVar } from '../../operations/localState/reactiveVariables';
import {
  IS_LOGGED_IN,
  RETRIEVE_BOOKING_BY_PROFILE,
  LAUNCH_DARKLY_FLAGS_AIR,
} from '../../operations/queries';
import setParams from '../../operations/localState/setParams';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import AirLoader from '../../components/AirLoader';
import SignInModal from '../../components/SignInModal';
import { trackBookFlightsView, trackError } from '../../utils/analytics/browseTracking';
import NotificationBannerComponent from '../../components/NotificationBanner';
import useCommonStyles from '../../utils/useCommonStyles';

const currentBrand = getBrand();
const manageSessionStorage = () => {
  sessionStorage.removeItem(SESSION_STORAGE_BOOKING_PROFILE_NAME);
  sessionStorage.removeItem(TRAVEL_AGENT_RESERVE);
  sessionStorage.removeItem(SESSION_STORAGE_AMEND_ORIGIN);
  sessionStorage.removeItem(SESSION_STORAGE_BOOKING_TOKEN_NAME);
  sessionStorage.removeItem(CANCEL_FLIGHT_RESPONSE_SUCCESSFUL);
  sessionStorage.removeItem(SESSION_STORAGE_FLIGHT_TYPE_CODE);
  setSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS, false);
  setSessionStorageItem(SESSION_STORAGE_AIR_REDIRECT_ERROR, null);
  setSessionStorageItem(SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS, null);
  setSessionStorageItem(SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS, null);
  setSessionStorageItem(SESSION_STORAGE_NAVIGATION_HISTORY_LAST_ENTRY, '');
};
const BookFlights = () => {
  const getDictionary = useDictionary(Dictionary);
  const {
    data: { lang, currency, country: globalCountry, market },
  } = useGlobal();

  const globalData = {
    country: globalCountry,
    language: lang,
    currency,
  };

  const basePath = globalizationPath(market, lang, '');
  const { host } = window.location;
  const dynamicDomainPerBrand = `${host}`;

  const generateAlternateLinks = (domain) => {
    const baseHref = `https://${domain}`;
    const pathName = '/flights/bookFlights';

    return [
      { href: `${baseHref}${pathName}`, hreflang: 'x-default' },
      { href: `${baseHref}${pathName}`, hreflang: 'en-us' },
      { href: `${baseHref}/can/en${pathName}`, hreflang: 'en-ca' },
      { href: `${baseHref}/irl/en${pathName}`, hreflang: 'en-ie' },
      { href: `${baseHref}/gbr/en${pathName}`, hreflang: 'en-gb' },
      { href: `${baseHref}/aus/en${pathName}`, hreflang: 'en-au' },
      { href: `${baseHref}/nzl/en${pathName}`, hreflang: 'en-nz' },
    ];
  };

  const classes = useStyles();
  const styles = useCommonStyles();
  const client = useApolloClient();
  const [profileAccessToken, setProfileAccessToken] = useState(
    getCookies(COOKIE_KEYS.ACCESS_TOKEN),
  );
  const [errorBanner, setErrorBanner] = useState(false);
  const [singleProfileBooking, setSingleProfileBooking] = useState(null);
  const [showNotification, setNotification] = useState(true);
  const [hasAllGuestsFlights, setHasAllGuestsFlights] = useState(null);
  const [errorBannerTitle, setErrorBannerTitle] = useState('');
  const [errorBannerMessage, setErrorBannerMessage] = useState('');
  const [errorBannerType, setErrorBannerType] = useState('');
  const [errorLink, setErrorLink] = useState('');
  const [bookingInfo, setBookingInfo] = useState(null);
  const [errorLinkHref, setErrorLinkHref] = useState('');
  const [loginModal, setLoginModal] = useState(false);
  const gaProfileBookingsLength =
    getSessionStorageItem(GA_PROFILE_BOOKINGS_LENGTH) === null
      ? 1
      : getSessionStorageItem(GA_PROFILE_BOOKINGS_LENGTH);
  const urlPath = globalizationPath(market, lang, NAVIGATION_PATHS.base);

  const [loginProfile, { loading: profileLoading, data: profileData, error: profileError }] =
    useLazyQuery(RETRIEVE_BOOKING_BY_PROFILE, {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    });

  const flagsVariables = {
    ldUser: LDUser(),
    language: lang,
    clientApp: APPLICATION_NAME,
    application: APPLICATION_NAME,
    brand: currentBrand.ldBrand,
    bookingCountry: globalCountry,
  };
  const { data: initialFlags, loading: initialFlagLoading } = useQuery(LAUNCH_DARKLY_FLAGS_AIR, {
    fetchPolicy: 'network-only',
    variables: flagsVariables,
  });

  const currentTabTraking = 'bookFlightlookup';

  const isCelebrityBrand = currentBrand.id === 'cel';

  const getCelebrityUrl = (redirectionType) => {
    const { bookingId, lastName, sailDate, shipCode } = bookingInfo;
    return `${
      redirectionType === REDIRECTION_MANAGE
        ? NAVIGATION_PATHS.manageVacations
        : NAVIGATION_PATHS.timeline
    }?bid=${bookingId}&sdt=${sailDate}&scd=${shipCode}&lnm=${lastName}&gic=true`;
  };

  const getFlightsBooked = (flightProfile) => {
    return flightProfile?.guests?.every(({ flightGuest }) => flightGuest?.guestFlights);
  };

  const hasAtLeastOneFlightBooked = (flightProfile) => {
    return flightProfile?.guests?.some(({ flightGuest }) => flightGuest?.guestFlights) || false;
  };
  const getLinkInformation = (dictionary, redirectionType) => {
    return isCelebrityBrand ? getCelebrityUrl(redirectionType) : dictionary;
  };
  const [excecuteLaunchDarklyFlag, { data: ldFlagsData, loading: ldLoading }] = useLazyQuery(
    LAUNCH_DARKLY_FLAGS_AIR,
    {
      fetchPolicy: 'no-cache',
    },
  );

  useEffect(() => {
    manageSessionStorage();
    setSelectedDeparture(null);
    setSelectedReturn(null);
    setHeldReservation(null);
    setSearchParams(null);
    setBrowseParams(null);
    setSearchType(null);
    setBookingProfile({
      bookingToken: null,
      airports: { nodes: [] },
      flightProfile: null,
    });
    setBookingToken(null);
    setParams(null);
    client.writeQuery({ query: IS_LOGGED_IN, data: { isLoggedIn: false } });
    trackBookFlightsView();
    // eslint-disable-next-line
  }, []);
  const makeProfileRetrieveBookingLogin = (variables) => {
    loginProfile({ variables });
  };

  useEffect(() => {
    if (initialFlags && profileAccessToken && gaProfileBookingsLength) {
      const isSigninEnabled = initialFlags?.ldFlags[ENABLE_SIGN_IN_FLAG];
      if (isSigninEnabled) {
        const variables = {
          accessToken: profileAccessToken,
        };
        makeProfileRetrieveBookingLogin(variables);
      }
    }
  }, [profileAccessToken, initialFlags]);

  useEffect(() => {
    setNotification(true);
  }, [errorBanner, errorBannerTitle]);

  const handleErrorBanner = ({ title, message, type = 'error', linkLabel, linkDestination }) => {
    setErrorBanner(true);
    setErrorBannerTitle(title);
    setErrorBannerMessage(message);
    setErrorBannerType(type);
    setErrorLink(linkLabel);
    setErrorLinkHref(linkDestination);
    document.querySelector('.main-container').scrollTo(0, 0);
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (profileData?.retrieveBookingsByProfile?.length === 1) {
      const { country, token } = profileData.retrieveBookingsByProfile[0];
      setSessionStorageItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, token);
      setSingleProfileBooking(profileData.retrieveBookingsByProfile[0]);
      const bookingDetails = {
        bookingId: profileData.retrieveBookingsByProfile[0]?.id,
        shipCode: profileData.retrieveBookingsByProfile[0]?.sailing.itinerary.ship.code,
        sailDate: profileData.retrieveBookingsByProfile[0]?.sailing.sailDate,
        lastName: profileData.retrieveBookingsByProfile[0]?.guests[0].lastName,
      };

      setBookingInfo(bookingDetails);
      const { flightProfile } = singleProfileBooking || {};
      setHasAllGuestsFlights(getFlightsBooked(flightProfile));
      excecuteLaunchDarklyFlag({
        variables: {
          ...flagsVariables,
          officeID: country?.office?.code,
          country: country?.code,
        },
      });
    } else if (profileData?.retrieveBookingsByProfile?.length === 0) {
      return handleErrorBanner({
        title: getDictionary(Dictionary.airNoReservations.key),
        message: getDictionary(Dictionary.airNoReservationsDetails.key),
        type: BANNER_TYPES.info,
      });
    } else if (profileData?.retrieveBookingsByProfile?.length > 1) {
      if (!isCelebrityBrand) {
        return handleErrorBanner({
          title: getDictionary(Dictionary.multipleReservationTitle.key),
          message: getDictionary(Dictionary.multipleReservationDetails.key),
          linkLabel: getDictionary(
            Dictionary
              .airFlightBookFlightsReservationErrorSailingDateIsNotSupportedDescriptionLinkText.key,
          ),
          linkDestination: getAmendAuthRedirection(
            prefixPathVar,
            isCelebrityBrand,
            ldFlagsData?.ldFlags,
          ),
          type: BANNER_TYPES.info,
        });
      }
      return handleErrorBanner({
        title: getDictionary(Dictionary.multipleReservationTitle.key),
        message: getDictionary(Dictionary.multipleReservationDetails.key),
        type: BANNER_TYPES.info,
      });
    }
  }, [profileData, profileError]);

  const showCHErrorMessage = (type) => {
    const { chMessagesBookingTypes } = SHOW_CH_ERROR_BANNER;
    return chMessagesBookingTypes.includes(type);
  };

  const saveBookingToken = (token) => {
    if (token) {
      sessionStorage.setItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, token);
      setBookingToken(token);
      client.writeQuery({ query: IS_LOGGED_IN, data: { isLoggedIn: true } });
    }
  };
  const handleErrorsMessages = (error) => {
    if (error && Array.isArray(error.graphQLErrors)) {
      if (commonUtils?.findErrorCode(error, [ERROR_CODE017, ERROR_CODE293])) {
        trackError(TRACK_INVAID, currentTabTraking);
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorInvalidBookingInformationTitle.key,
          ),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorInvalidBookingInformationDescription.key,
          ),
        });
      }
      if (findErrorMessage(error, 'BOOKING IS LOCKED')) {
        trackError(TRACK_LOCKED, currentTabTraking);
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorBookingTemporarilyLockedTitle.key,
          ),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorBookingTemporarilyLockedDescription.key,
          ),
        });
      }
      if (commonUtils.findErrorCode(error, TRACK_INCORRECT_SAILING)) {
        if (singleProfileBooking) {
          const { token } = singleProfileBooking;
          saveBookingToken(token);
        }
        trackError('sailing date not supported', currentTabTraking);

        if (singleProfileBooking?.type === TRAVEL_AGENT) {
          return handleErrorBanner({
            title: getDictionary(
              Dictionary.airFlightBookFlightsReservationErrorSailingDateIsNotSupportedTitle.key,
            ),
            message: getDictionary(
              Dictionary.airFlightBookFlightsReservationTaErrorSailingDateNotSupportedDescription
                .key,
            ),
          });
        }
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorSailingDateIsNotSupportedTitle.key,
          ),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorSailingDateIsNotSupportedDescription.key,
          ),
          type: BANNER_TYPES.warning,
        });
      }
      if (commonUtils.findErrorCode(error, TRACK_ERROR_CANCELLED)) {
        trackError(TRACK_STATUS_CANCELLED, currentTabTraking);
        return handleErrorBanner({
          title: getDictionary(Dictionary.airFlightBookFlightsReservationErrorCancelledTitle.key),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorCancelledDescription.key,
          ),
        });
      }
      if (commonUtils.findErrorCode(error, FLIGHT_AGENCY_ERROR)) {
        if (singleProfileBooking) {
          const { token } = singleProfileBooking;
          saveBookingToken(token);
        }
        trackError('country is not supported', currentTabTraking);
        if (singleProfileBooking?.type === TRAVEL_AGENT) {
          return handleErrorBanner({
            title: getDictionary(
              Dictionary.airFlightBookFlightsReservationErrorCruiseNonEligibleTitle.key,
            ),
            message: getDictionary(
              Dictionary.airFlightBookFlightsReservationTaErrorCruiseNonEligibleDescription.key,
            ),
          });
        }
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorCruiseNonEligibleTitle.key,
          ),
          message: `${getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorCruiseNonEligibleDescription.key,
          )}`,
          linkLabel: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorCruiseNonEligibleDescriptionLinkText.key,
          ),
          linkDestination: getLinkInformation(
            getDictionary(Dictionary.airFlightReservationDashboarddDescriptionLink.key),
            REDIRECTION_MANAGE,
          ),
          type: BANNER_TYPES.warning,
        });
      }
      if (commonUtils.findErrorCode(error, ACE_FS_1006_ERROR)) {
        trackError('not found', currentTabTraking);

        return handleErrorBanner({
          title: getDictionary(Dictionary.airBookFlightNoResultsTitle.key),
          message: `${getDictionary(Dictionary.airBookFlightNoResultsDescription.key)} ${
            initialFlags?.ldFlags[SUPPORT_PHONE_NUMBER_LD_FLAG]
          } ${getDictionary(Dictionary.airFlightSearchErrorAssistance.key)} `,
        });
      }
      if (commonUtils.findErrorCode(error, ACE_FS_1028_ERROR)) {
        trackError('not found', currentTabTraking);

        return handleErrorBanner({
          title: getDictionary(Dictionary.airBookFlightNoResultsTitle.key),
          message: `${getDictionary(Dictionary.airBookFlightSearchErrorDescription.key)} ${
            initialFlags?.ldFlags[SUPPORT_PHONE_NUMBER_LD_FLAG]
          } ${getDictionary(Dictionary.airFlightSearchErrorAssistance.key)} `,
        });
      }
      if (commonUtils.findErrorCode(error, ACE_FS_1019_ERROR)) {
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorSailingDateIsNotSupportedTitle.key,
          ),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorSailingDateIsNotSupportedDescription.key,
          ),
          type: BANNER_TYPES.warning,
        });
      }
      if (!hasAllGuestsFlights) {
        if (commonUtils.findErrorCode(error, SEARCH_SAME_AIRPORT_ERROR)) {
          trackError('Unsupported', currentTabTraking);
          return handleErrorBanner({
            title: getDictionary(Dictionary.airBrowsePageFormTypeLabelSameAirpotTitleError.key),
            message: getDictionary(Dictionary.airBrowsePageFormTypeLabelSameAirpotError.key),
          });
        }
        trackError('technical issue', currentTabTraking);
        return handleErrorBanner({
          title: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorTechnicalIssuesTitle.key,
          ),
          message: getDictionary(
            Dictionary.airFlightBookFlightsReservationErrorTechnicalIssuesDescription.key,
          ),
        });
      }
    }
    return false;
  };
  const checkCourtesyHold = (bookingError, bookingData) => {
    if (bookingError && Array.isArray(bookingError.graphQLErrors)) {
      const redirectErrors = ['BOOKING_STATUS_COURTESY_HOLD'];
      const errorFoundToAmendRedirect = commonUtils.findErrorCode(bookingError, redirectErrors);

      if (errorFoundToAmendRedirect) {
        let showCHBanner = false;
        if (bookingData?.retrieveBooking) {
          const { token, booking } = bookingData.retrieveBooking;
          showCHBanner = showCHErrorMessage(booking.type);
          saveBookingToken(token);
        }
        if (!showCHBanner) {
          setSessionStorageItem(
            SESSION_STORAGE_AIR_REDIRECT_ERROR,
            errorFoundToAmendRedirect.extensions.code,
          );
          sessionStorage.setItem('air-ch', true);
          handleErrorBanner({
            title: getDictionary(Dictionary.airCourtesyHoldErrorTitle.key),
            message: getDictionary(Dictionary.airCourtesyHoldErrorDescription.key),
            linkLabel: getDictionary(
              Dictionary
                .airFlightBookFlightsReservationErrorSailingDateIsNotSupportedDescriptionLinkText
                .key,
            ),
            linkDestination: getLinkInformation(
              getDictionary(Dictionary.airFlightReservationDashboarddDescriptionLink.key),
              REDIRECTION_MANAGE,
            ),
            type: BANNER_TYPES.warning,
          });
        } else {
          handleErrorBanner({
            title: getDictionary(Dictionary.airCourtesyHoldErrorTitleTA.key),
            message: getDictionary(Dictionary.airCourtesyHoldErrorDescriptionTA.key),
            type: BANNER_TYPES.error,
          });
        }
        return true;
      }
      handleErrorsMessages(bookingError);
    }
    return false;
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (ldFlagsData && singleProfileBooking) {
      const hasUndefinedGuest = hasGuestUndefined(singleProfileBooking?.guests);
      if (hasUndefinedGuest) {
        handleErrorBanner({
          title: getDictionary(Dictionary.airTbaBannerTitle.key),
          message: `${getDictionary(Dictionary.airTbaBannerDescription.key)}`,
          linkLabel: getDictionary(Dictionary.airTbaBannerTextLink.key),
          linkDestination: getLinkInformation(
            `${basePath}${getDictionary(Dictionary.airTbaBannerDescriptionUrl.key)}`,
            REDIRECTION_MANAGE,
          ),
          type: BANNER_TYPES.warning,
        });
      }

      const { allowedBookingTypes } = ldFlagsData.ldFlags[ENABLE_CRUISE_BOOKING_TYPE_FLAG];
      if (allowedBookingTypes.length !== 0) {
        if (
          allowedBookingTypes[0] !== '*' &&
          singleProfileBooking?.type &&
          !allowedBookingTypes.includes(singleProfileBooking?.type)
        ) {
          return handleErrorBanner({
            title: getDictionary(
              Dictionary.airFlightBookFlightsReservationErrorUnsupportedBookingTitle.key,
            ),
            message: getDictionary(
              Dictionary.airFlightBookFlightsReservationErrorUnsupportedBookingDescription.key,
            ),
          });
        }
      }
    }

    if (profileError) {
      checkCourtesyHold(profileError, singleProfileBooking);
    }
    if (singleProfileBooking) {
      const { flightProfile, token, country } = singleProfileBooking || {};
      setSessionStorageItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, token);
      const guestFlights = hasAtLeastOneFlightBooked(flightProfile);

      if (guestFlights && !profileError) {
        setSessionStorageItem(BOOKING_COUNTRY, {
          country: country?.code,
          officeID: country?.office?.code,
        });
        window.location.assign(
          `${prefixPathVar()}/flights${NAVIGATION_PATHS.manage}?token=${token}`,
        );
      } else if (!guestFlights && !profileError) {
        window.location.assign(`${urlPath}${NAVIGATION_PATHS.resultsDeparture}`);
      }
    }
  }, [ldFlagsData]);

  const handleSignInClick = () => {
    setLoginModal(true);
    const dataLayer = {
      ...globalData,
      interaction: `signIn:authentication:clicked`,
      eventType: 'interaction',
    };
    trackInteraction(dataLayer);
  };
  const handleCloseModal = () => {
    setLoginModal(false);
    const dataLayer = {
      ...globalData,
      interaction: `airbooking:login:close`,
      eventType: 'interaction',
    };
    trackInteraction(dataLayer);
  };

  const isSigninEnabled = initialFlags?.ldFlags[ENABLE_SIGN_IN_FLAG];
  return (
    <div className={classes.bookFlights}>
      <AirLoader
        open={profileLoading || ldLoading || initialFlagLoading}
        status={profileLoading && getDictionary(Dictionary.loaderSignIn.key)}
      />
      <Helmet>
        <title>{getDictionary(Dictionary.airSearchTabsSeoTitle.key)}</title>
        <meta
          name="description"
          content={getDictionary(Dictionary.airSearchTabsSeoDescription.key)}
        />
        <link rel="canonical" href={getDictionary(Dictionary.airSearchTabsSeoUrl.key)} />
        {generateAlternateLinks(dynamicDomainPerBrand).map((link) => (
          <link
            rel="alternate"
            key={`${link.href}-${link.hreflang}`}
            href={link.href}
            hrefLang={link.hreflang}
          />
        ))}
      </Helmet>
      <div className={classes.container}>
        {errorBanner && showNotification && (
          <div className={`${styles.notification} ${classes.bannerNotification}`}>
            <NotificationBannerComponent
              title={errorBannerTitle}
              description={errorBannerMessage}
              type={errorBannerType}
              linkLabel={errorLink}
              linkDestination={errorLinkHref}
              renderCloseBtn
              isBannerOpen
              onClose={() => {
                setErrorBanner(false);
                setNotification(!showNotification);
              }}
            />
          </div>
        )}
        <div>
          <h1>{getDictionary(Dictionary.airBookflightsTitle.key)}</h1>
        </div>
        {isSigninEnabled && !profileAccessToken && (
          <div className="signup">
            <>
              <SignInModal
                closeModal={() => setLoginModal(false)}
                setLoginModal={setLoginModal}
                open={loginModal}
                isCelebrityBrand={isCelebrityBrand}
                setProfileAccessToken={setProfileAccessToken}
                setGuestName="reservation.setGuestName">
                <Box className={classes.modalContainer}>
                  <MuiButton variant="text" onClick={handleCloseModal} disableTouchRipple>
                    <CloseIcon />
                  </MuiButton>
                </Box>
              </SignInModal>
            </>
            <div>
              <h2 className="loginComponent">{getDictionary(Dictionary.airSignInTitle.key)}</h2>
              <p className="loginSubtitle">{getDictionary(Dictionary.airSignInSubtitle.key)}</p>
            </div>
            <Button
              variant="contained"
              className="loginButton"
              color="primary"
              onClick={handleSignInClick}>
              {getDictionary(Dictionary.airSignInCta.key)}
            </Button>
          </div>
        )}

        <SearchTabs handleErrorBanner={handleErrorBanner} />
        <WhyChooseUsUnified />

        <QuestionsUnified />
      </div>
    </div>
  );
};
export default BookFlights;
